import { z } from 'zod';

const status = z.enum(['Success', 'Failed']);

const tableDataSchema = z.object({
  value: z.union([z.string(), z.number(), status]),
  tooltip: z.string().optional(),
  logo: z.string().nullish(),
});

const columnsTypeSchema = z.enum(['text', 'directional', 'number', 'status']);

const tableColumnsSchema = z.object({
  type: columnsTypeSchema,
  sticky: z.boolean().nullish(),
  tooltip: z.string().optional(),
  id: z.string(),
  title: z.string(),
});

const tableRowSchema = z.record(z.string(), tableDataSchema);

export const tablePayloadSchema = z.object({
  id: z.string(),
  title: z.string(),
  data: z.array(tableRowSchema),
  stickyHeader: z.boolean().nullish(),
  columnsMeta: z.array(tableColumnsSchema),
  pagination: z
    .object({
      itemsPerPage: z.number().nullish(),
      strategy: z.enum(['scroll', 'buttons']).nullish(),
    })
    .nullish(),
});

export type TableRow = z.infer<typeof tableRowSchema>;
export type TableColumns = z.infer<typeof tableColumnsSchema>;

export type TablePayload = z.infer<typeof tablePayloadSchema>;
